module.exports = __webpack_public_path__ + "media/images/icon_x-7b9212a5932da61f5d5249a94c3433d1.svg";